export default "__VITE_ASSET__CNrDltg2__"